module.exports = __webpack_public_path__ + "img/poly-2.1b1bacca.png";